import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

type CardPadding = 'none' | 'sm' | 'md' | 'lg' | 'xl'
type CardVariant = 'default' | 'interactive'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding
  variant?: CardVariant
}

const paddingClasses: Record<CardPadding, string> = {
  none: 'card-base',
  sm: 'card-p-sm',
  md: 'card-p-md',
  lg: 'card-p-lg',
  xl: 'card-p-xl',
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, padding = 'md', variant = 'default', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          paddingClasses[padding],
          variant === 'interactive' && 'surface-interactive',
          className
        )}
        {...props}
      />
    )
  }
)
Card.displayName = 'Card'
